import RestApi from './../../api/rest-api-client'
const srvcEndpoint = '/users_university_sessions'
export default {
  search: async (req, opts) => RestApi.request('GET', srvcEndpoint, req, opts),
  get: async (id, req, opts) => RestApi.request('GET', srvcEndpoint, id, req, opts),
  store: async (data, opts) => RestApi.request('POST', srvcEndpoint, data, opts),
  update: async (id, data, opts) => RestApi.request('PUT', srvcEndpoint, id, data, opts),
  delete: async (id, opts) => RestApi.request('DELETE', srvcEndpoint, id, opts),

  // Admin enrollee management
  initiate: async (enrollmentId, opts) => RestApi.request('POST', srvcEndpoint + `/${enrollmentId}/initiate`, {}, opts),
  complete: async (enrollmentId, opts) => RestApi.request('POST', srvcEndpoint + `/${enrollmentId}/complete`, {}, opts),
  cancel: async (enrollmentId, issueRefund = false, opts) =>
    RestApi.request('POST', srvcEndpoint + `/${enrollmentId}/cancel`, { issue_refund: issueRefund }, opts),

  // Change session: reassign enrollee to a different session (admin only, initiated_at must be NULL)
  changeSession: async (enrollmentId, targetSessionId, opts) =>
    RestApi.request(
      'POST',
      srvcEndpoint + `/${enrollmentId}/change-session`,
      { target_session_id: targetSessionId },
      opts
    ),

  // Export session enrollees with enriched user data
  exportBySession: async (sessionId, opts) =>
    RestApi.request('GET', srvcEndpoint + `/export-by-session/${sessionId}`, {}, opts),

  // Bulk operations
  bulkInitiate: async (enrollmentIds, opts) =>
    RestApi.request('POST', srvcEndpoint + '/bulk-initiate', { enrollment_ids: enrollmentIds }, opts),
  bulkComplete: async (enrollmentIds, opts) =>
    RestApi.request('POST', srvcEndpoint + '/bulk-complete', { enrollment_ids: enrollmentIds }, opts),
}
